import { useQuery } from '@tanstack/react-query';
import {
  kiralamaGetir,
  kiralamalariListele,
  type KiralamaSorgusu,
  type SayfalanmisKiralamalar,
} from '@emanetx/sdk';
import { istemci } from '../istemci.js';

export function useKiralamaListesi(sorgu: Partial<KiralamaSorgusu>) {
  return useQuery<SayfalanmisKiralamalar>({
    queryKey: ['kiralamalar', 'liste', sorgu],
    queryFn: () => kiralamalariListele(istemci, sorgu),
    placeholderData: (onceki) => onceki,
  });
}

export function useKiralama(id: string | undefined | null) {
  return useQuery({
    queryKey: ['kiralamalar', 'detay', id ?? ''],
    queryFn: () => kiralamaGetir(istemci, id as string),
    enabled: !!id,
  });
}
